// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import InvoiceEditScreen from "../../src/screens/invoices/edit-screen"
import ScreenTitle from "../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} InvoiceNewRouteProps */

/** @typedef {Record<string, never>} InvoiceNewRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<InvoiceNewRouteProps, InvoiceNewRouteState>}
 */
class InvoiceNewRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("New invoice")}</ScreenTitle>
        <InvoiceEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<InvoiceNewRouteProps>} */
const InvoiceNewRouteComponent = memo(shapeComponent(InvoiceNewRoute))

export default InvoiceNewRouteComponent
